import { ActionReducerMap } from '@ngrx/store'
import { loadingReducer } from './loading/loading.reducer'
import { userReducer } from './user/user.reducer'

export const stateReducers: ActionReducerMap<any> = {
    loading: loadingReducer,
    user: userReducer,
}
